import React from 'react';
import Select, { GroupBase, Props, StylesConfig } from 'react-select';
import theme from '../theme/theme';

export interface ExtendedProps<T> {
    onOptionFocus?: (e: T) => void;
}

function styles<Option, IsMulti extends boolean = false, Group extends GroupBase<Option> = GroupBase<Option>>(): StylesConfig<Option, IsMulti, Group> {
    return {
        option: (provided, state) => {
            return {
                ...provided,
                fontSize: theme.input.textSize,
                color: state.isSelected ? 'white' : theme.input.color
            };
        },
        valueContainer: (provided) => {
            return {
                ...provided,
                fontSize: theme.input.textSize,
                color: theme.input.color
            };
        },
        menu: (provided) => {
            return {
                ...provided,
                zIndex: 2
            };
        },
        control: (provided, state) => {
            return {
                ...provided,
                position: 'relative',
                borderWidth: 1,
                borderStyle: 'solid',
                borderColor: state.isFocused ? theme.app.primary : '#DDD',
                boxShadow: 'none',
                minHeight: 40,
                ':hover': {
                    borderColor: theme.app.primary
                }
            };
        }
    };
}

export const AdvancedSelect = <Option, IsMulti extends boolean = false, Group extends GroupBase<Option> = GroupBase<Option>>(
    props: Props<Option, IsMulti, Group> & ExtendedProps<Option>
) => {
    return <Select {...props} styles={{ ...styles<Option, IsMulti, Group>(), ...props.styles }} />;
};
